import { AnyAction, Reducer } from 'redux';
import actionTypes from '../types/newAppointmentTypes';

const initialState = {
  appointmentFormVal: {},
  selectedOption: '',
  subCategoryData: [],
  selectedSubCategory: '',
  timeSlots: [],
  appointmentDate: '',
};

const setAppointmentFormVal = (state: any, { appointmentFormVal }: AnyAction): any => ({
  ...state, ...{ appointmentFormVal },
});

const reducer: Reducer<any> = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SET_APPOINTMENT_FORM_VAL:
      return setAppointmentFormVal(state, action);
    case actionTypes.SET_OPTION:
      return {
        ...state,
        selectedOption: action.payload,
      };
    case actionTypes.SUB_CATEGORIES_DATA:
      return {
        ...state,
        subCategoryData: action.payload,
      };
    case actionTypes.SET_SUB_CATEGORY_OPTION:
      return {
        ...state,
        selectedSubCategory: action.payload,
      };
    case actionTypes.SET_TIME_SLOTS:
      return {
        ...state,
        timeSlots: action.payload,
      };
    case actionTypes.SET_APPOINTMENT_DATE:
      return {
        ...state,
        appointmentDate: action.payload,
      };
    default: return state;
  }
};

export { reducer as newAppointmentReducer };
